/**
 * WrappedTeaserSection
 *
 * Teases the "Relationship Wrapped" year-end feature.
 * Full-width navy background. Left: copy. Right: mock Wrapped card.
 */

const stats = [
  { value: '12', label: 'cards sent' },
  { value: '8',  label: 'relationships honored' },
  { value: '4',  label: 'occasion types' },
  { value: '3',  label: 'countries reached' },
];

export default function WrappedTeaserSection() {
  return (
    <section className="bg-navy py-20">
      <div className="section-container">

        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16">

          {/* LEFT: copy */}
          <div className="flex-1 text-center md:text-left">
            <span className="font-body text-xs tracking-widest uppercase text-gold font-semibold mb-4 block">
              Your year in cards, updated live
            </span>
            <h2 className="font-heading text-4xl md:text-5xl text-white mb-6 leading-tight">
              Your Year in Cards.
            </h2>
            <p className="font-body text-white/70 text-base md:text-lg leading-relaxed mb-8 max-w-md mx-auto md:mx-0">
              Every December, we create your personal Relationship Wrapped, a shareable
              summary of every card sent, every relationship honored, every moment you
              made count. Because doing the right thing should feel good.
            </p>
            <button
              onClick={() => document.getElementById('signup')?.scrollIntoView({ behavior: 'smooth' })}
              className="inline-flex items-center gap-2 font-body font-semibold text-white border border-sage px-6 py-3 rounded-full hover:bg-sage/20 transition-colors duration-200"
            >
              Join to unlock →
            </button>
          </div>

          {/* RIGHT: mock Wrapped card */}
          <div className="flex-shrink-0">
            <div
              style={{
                background: 'linear-gradient(145deg, #1A1410 0%, #0D0905 100%)',
                borderRadius: 16,
                padding: '2rem 2rem 1.75rem',
                width: 240,
                boxShadow: '0 20px 60px rgba(0,0,0,0.4), 0 4px 16px rgba(0,0,0,0.25)',
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              {/* Sparkle decoration */}
              <div aria-hidden="true" style={{ position: 'absolute', top: 14, right: 18, fontSize: 18, opacity: 0.5 }}>✦</div>
              <div aria-hidden="true" style={{ position: 'absolute', top: 38, right: 36, fontSize: 10, opacity: 0.35 }}>✦</div>
              <div aria-hidden="true" style={{ position: 'absolute', bottom: 60, left: 14, fontSize: 12, opacity: 0.3 }}>✦</div>

              {/* Year */}
              <p
                className="font-heading text-gold leading-none mb-1"
                style={{ fontSize: 52, fontWeight: 700 }}
              >
                {new Date().getFullYear()}
              </p>

              {/* Sub-label */}
              <p
                className="font-body text-white/50 uppercase tracking-widest mb-6"
                style={{ fontSize: 9, letterSpacing: '0.18em' }}
              >
                Relationship Wrapped
              </p>

              {/* Stats */}
              <div className="space-y-3 mb-6">
                {stats.map((s) => (
                  <div key={s.label} className="flex items-baseline gap-2">
                    <span className="font-heading text-gold text-2xl leading-none">{s.value}</span>
                    <span className="font-body text-white/60 text-xs">{s.label}</span>
                  </div>
                ))}
              </div>

              {/* Divider */}
              <div style={{ borderTop: '1px solid rgba(255,255,255,0.12)', paddingTop: '0.75rem' }}>
                <p
                  className="font-heading text-white/40 text-center tracking-widest uppercase"
                  style={{ fontSize: 10 }}
                >
                  MomentSent
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
